import {WhitelabelEvent, WhitelabelEventWithPayload} from "../../../../common/ts/events/Events";

export class NextPagePaginatedEvent implements WhitelabelEvent {
    type: string;
    static readonly TYPE: string = 'next-page-paginated';

    constructor() {
        this.type = NextPagePaginatedEvent.TYPE;
    }
}

export class PreviousPagePaginatedEvent implements WhitelabelEvent {
    type: string;
    static readonly TYPE: string = 'previous-page-paginated';

    constructor() {
        this.type = PreviousPagePaginatedEvent.TYPE;
    }
}

interface PagePaginatedEventPayload {
    pageNumber: string | null,
}

export class PagePaginatedEvent implements WhitelabelEventWithPayload<PagePaginatedEventPayload> {
    payload: PagePaginatedEventPayload;
    type: string;
    static readonly TYPE: string = 'page-paginated';

    constructor(payload: PagePaginatedEventPayload) {
        this.type = PagePaginatedEvent.TYPE;
        this.payload = payload;
    }
}
